import React, { useContext, useMemo } from 'react'
import { useTranslate } from 'react-polyglot'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faIdCard } from '@fortawesome/pro-light-svg-icons'
import { faRedo } from '@fortawesome/pro-regular-svg-icons'

import { SIGNING_CARD_STATUS } from 'src/constants'
import './signing_card_status.css'
import { eIDSignerContext } from '../../../contexts/eIDSigner'

const STATUS_COLORS = Object.freeze({
  [SIGNING_CARD_STATUS.CONTACTING_SERVER]:          '#637E8A',
  [SIGNING_CARD_STATUS.READER_UNAVAILABLE]:         '#1E274F',
  [SIGNING_CARD_STATUS.UNKNOWN_CARD]:               '#F10036',
  [SIGNING_CARD_STATUS.CARD_UNAVAILABLE]:           '#F10036',
  [SIGNING_CARD_STATUS.ERROR_READING_DATA]:         '#F10036',
  [SIGNING_CARD_STATUS.CANCELED_DURING_PROCESSING]: '#F10036',
  [SIGNING_CARD_STATUS.CARD_INTERNAL_ERROR]:        '#F10036',
  [SIGNING_CARD_STATUS.ERROR_READING_ID_DATA]:      '#F10036',
  [SIGNING_CARD_STATUS.READING_CARD]:               '#F5900C',
  [SIGNING_CARD_STATUS.AVAILABLE]:                  '#0DBDA7',
  [SIGNING_CARD_STATUS.NO_PICTURE]:                 '#0DBDA7',
  [SIGNING_CARD_STATUS.SERVER_UNREACHABLE]:         '#637E8A',
  [SIGNING_CARD_STATUS.SERVER_UNAVAILABLE]:         '#1E274F',
  [SIGNING_CARD_STATUS.OLD_VERSION]:                '#637E8A',
  [SIGNING_CARD_STATUS.SIGNING]:                    '#F5900C'
})

const SigningCardStatus = React.memo(function SigningCardStatus () {
  const context = useContext(eIDSignerContext)
  const t = useTranslate()
  const color = useMemo(
    () => STATUS_COLORS[context.cardStatus] || STATUS_COLORS[SIGNING_CARD_STATUS.SERVER_UNAVAILABLE],
    [context.cardStatus]
  )
  return (
    <div className='card-status'>
      <div className='card-reader-left'>
        <span className='card-reader-icon' style={{ color }}>
          <FontAwesomeIcon icon={faIdCard} />
        </span>
        <span className='card-reader-text' style={{ color }}>
          {t(`cardStatus.${context.cardStatus}.text`)}
        </span>
      </div>
      {context.cardStatus === SIGNING_CARD_STATUS.SERVER_UNAVAILABLE && (
        <button type='button' className='retry-button' onClick={context.retryServer}>
          <FontAwesomeIcon icon={faRedo} />
          <span>{t('cardStatus.tryAgain')}</span>
        </button>
      )}
    </div>
  )
})

export default SigningCardStatus
